/**
 * 深拷贝
 * @returns {any}
 */
export const deepClone = (val: any, map = new WeakMap()) => {
  if (typeof val !== 'object' || val == null) return val;
  if (map.has(val)) return map.get(val);
  const clone = Array.isArray(val) ? [] : {};
  map.set(val, clone);
  const keys = Object.keys(val).concat(Object.getOwnPropertySymbols(val) as any);
  let len = keys.length;
  while (len--) {
    clone[keys[len]] = deepClone(val[keys[len]], map);
  }
  return clone;
};
